function getNewestSubmissions() {
  $.ajax({
    method: "GET",
    url: webApplicationBaseURL + "servlets/solr/search?rows=5",
    dataType: "html"
  }).done( function( html ) {
    var hitListHtml = $(html).find('#hit_list').html();
    if(hitListHtml.includes("hit_1")) {
      $('#hit_list').html(hitListHtml);
      $('.hit_counter').html("&nbsp");
      $('.hit_options').html("&nbsp");
      $('.single_hit_option').html("&nbsp");
    }
  });
}

function getOpenSubmissions() {
  $.ajax({
    method: "GET",
    url: webApplicationBaseURL + "servlets/solr/select?q=createdby%3A" + currentUser + "%20AND%20(state%3A%22created%22%20OR%20state%3A%22submitted%22%20OR%20state%3A%22accepted%22)%20AND%20objectType%3A%22mods%22&sort=created+desc&rows=1000",
    dataType: "html"
  }).done( function( html ) {
    var hitListHtml = $(html).find('#hit_list').html();
    if(hitListHtml.includes("hit_1")) {
      $('#hit_list').html(hitListHtml);
      $('.hit_counter').html("&nbsp");
      $('.hit_options').html("&nbsp");
      $('.single_hit_option').html("&nbsp");
    } else {
      if(currentLang == 'de') {
        $('#hit_list').html('<div class="alert alert-info">Sie haben im Moment keine offenen Einreichungen.</div>');
      } else {
        $('#hit_list').html('<div class="alert alert-info">You don\'t have any open submissions at them moment.</div>');
      }
    }
  });
}

function getSubmissionsInReview() {
  $.ajax({
    method: "GET",
    url: webApplicationBaseURL + "servlets/solr/select?q=(state%3A%22submitted%22%20OR%20state%3A%22accepted%22)%20AND%20objectType%3A%22mods%22&sort=created+desc&rows=1000",
    dataType: "html"
  }).done( function( html ) {
    var hitListHtml = $(html).find('#hit_list').html();
    if(hitListHtml.includes("hit_1")) {
      $('#hit_list').html(hitListHtml);
      $('.hit_counter').html("&nbsp");
      $('.hit_options').html("&nbsp");
      $('.single_hit_option').html("&nbsp");
    } else {
      if(currentLang == 'de') {
        $('#hit_list').html('<div class="alert alert-info">Es befinden sich aktuell keine Publikationen im Review.</div>');
      } else {
        $('#hit_list').html('<div class="alert alert-info">There are no publications in review at them moment.</div>');
      }
    }
  });
}

function getSubmissionsInWorkspace(workspace) {
  $.ajax({
    method: "GET",
    url: webApplicationBaseURL + "servlets/solr/select?q=(state%3A%22submitted%22%20OR%20state%3A%22accepted%22)%20AND%20objectType%3A%22mods%22%20AND%20(lars.workspace%3A%22" + workspace + "%22)&sort=created+desc&rows=1000",
    dataType: "html"
  }).done( function( html ) {
    var hitListHtml = $(html).find('#hit_list').html();
    if(hitListHtml.includes("hit_1")) {
      $('#hit_list').html(hitListHtml);
      $('.hit_counter').html("&nbsp");
      $('.hit_options').html("&nbsp");
      $('.single_hit_option').html("&nbsp");
    } else {
      if(currentLang == 'de') {
        $('#hit_list').html('<div class="alert alert-info">Es befinden sich aktuell keine Publikationen im Review.</div>');
      } else {
        $('#hit_list').html('<div class="alert alert-info">There are no publications in review at them moment.</div>');
      }
    }
  });
}

function setNumOpenTasks() {
  if(userHasEditorRights == 'true') {
    $.ajax({
      method: "GET",
      url: webApplicationBaseURL + "servlets/solr/select?q=createdby%3A" + currentUser + "%20AND%20(state%3A%22created%22%20OR%20state%3A%22submitted%22%20OR%20state%3A%22accepted%22)%20AND%20%2BobjectType%3A%22mods%22&rows=0&wt=json",
      dataType: "json"
    }).done( function( data ) {
      var numFound = data.response.numFound;
      $('#num-open-own').html(numFound);
    });

    // retrieve genre and workflow facet for publications in review to determine open jobs per publication type
    $.ajax({
      method: "GET",
      url: webApplicationBaseURL + "servlets/solr/select?q=(state%3Asubmitted%20OR%20state%3Aaccepted)%20AND%20objectType%3Amods&rows=0&wt=json",
      dataType: "json"
    }).done( function( data ) {

      var numInWorkspace = {};
      var numInWorkspaceTotal = data.response.numFound;
      var workspaceFacet = data.facet_counts.facet_fields["lars.workspace"] || [];
      for(let i = 0; i < workspaceFacet.length; i += 2) {
        var workspaceName = workspaceFacet[i];
        var workspaceCount = workspaceFacet[i + 1];
        numInWorkspace[workspaceName] = workspaceCount;
      }
      
      $('#num-open-total').html(numInWorkspaceTotal);
      $("*[id^=num-open-workspace-]").each( function() {
        var workspaceName = $(this).attr("id").substr("num-open-workspace-".length);
        $(this).html(numInWorkspace[workspaceName] || 0);
      });

    });

  } else if(currentUser != null && currentUser != "guest") {
    // get number of open submissions for users (non admin, non editor)
    // cache result for 1 minute
    var storageKey = "num-open-own-" + currentUser;
    var hasStorage = ("sessionStorage" in window && window.sessionStorage),
        now, expiration, data = false;

    try {
      if (hasStorage) {
        data = sessionStorage.getItem(storageKey);
        if (data) {
          // extract saved object from JSON encoded string
          data = JSON.parse(data);

          // calculate expiration time for content,
          // to force periodic refresh after 1 minute
          now = new Date();
          expiration = new Date(data.timestamp);
          expiration.setMinutes(expiration.getMinutes() + 1);

          // ditch the content if too old
          if (now.getTime() > expiration.getTime()) {
            data = false;
            sessionStorage.removeItem(storageKey);
          }
        }
      }
    } catch (e) {
      data = false;
    }

    if (data) {
      // load data from session storage
      var numFound = data.content.response.numFound;
      $('#num-open-total').html(numFound);
      $('#num-open-own').html(numFound);
    } else {
      // fallback to AJAX loader
      $.ajax({
        type : "GET",
        url : webApplicationBaseURL + "servlets/solr/select?q=createdby%3A" + currentUser + "%20AND%20(state%3A%22created%22%20OR%20state%3A%22submitted%22%20OR%20state%3A%22accepted%22)%20AND%20%2BobjectType%3A%22mods%22&rows=0&wt=json",
        dataType : "json",
      }).done( function( data ) {
        // save in session storage if available
        if (hasStorage) {
          try {
            sessionStorage.setItem(storageKey, JSON.stringify({
              timestamp: new Date(),
              content: data
            }));
          } catch (e) {
            // silently suppress, it doesn't really matter
          }
        }

        // show the new content
        var numFound = data.response.numFound;
        $('#num-open-total').html(numFound);
        $('#num-open-own').html(numFound);
      });
    }
  }
}

function toggleDerivateDrop() {
    $(".drop-to-object-optional").toggle();
    var derivateButton = document.getElementById("derivate-toggle-button");
    if(derivateButton.classList.contains("btn-success")) {
      $(derivateButton.firstChild).removeClass("fa-plus");
      $(derivateButton.firstChild).addClass("fa-minus");
      $(derivateButton).removeClass("btn-success");
      $(derivateButton).addClass("btn-secondary");
    } else {
      $(derivateButton.firstChild).removeClass("fa-minus");
      $(derivateButton.firstChild).addClass("fa-plus");
      $(derivateButton).removeClass("btn-secondary");
      $(derivateButton).addClass("btn-success");
    }
};
